<template>
  <section class="vf-m-new-product-price">
    <span v-if="normalizedSpecial" class="vf-m-new-product-price__special">
      <span class="sr-only">Current price </span>{{ normalizedSpecial }}
    </span>
    <span
      v-if="normalizedSpecial"
      class="line-through vf-m-new-product-price__oldPrice"
    >
      <span class="sr-only">Retail price </span>{{ price }}
    </span>
    <span v-else class="vf-m-new-product-price__price">
      <span class="sr-only">Current price </span>{{ price }}
    </span>
    <span
      v-if="normalizedSpecial && price"
      class="vf-m-new-product-price__discount"
    >
      {{ calculateDiscount(price, normalizedSpecial) }}% OFF
    </span>
  </section>
</template>

<script setup lang="ts">
// @ts-ignore
import extractPrice from "~/core/utils/extractPrice.ts";
import { computed } from "vue";
import { normalizeProductSpecial } from "../../../utils/productPrice";

const props = defineProps({
  price: {
    type: String,
    default() {
      return "";
    },
  },
  special: {
    type: String,
    default() {
      return "";
    },
  },
  specialIsNormalized: {
    type: Boolean,
    default: false,
  },
});

const calculateDiscount = (priceStr: string, specialPriceStr: string) => {
  const price = extractPrice(priceStr);
  const specialPrice = extractPrice(specialPriceStr);

  // No discount if specialPrice is greater than or equal to price or any invalid value
  if (price <= 0 || specialPrice <= 0 || specialPrice >= price) {
    return 0;
  }

  const discount = ((price - specialPrice) / price) * 100;
  return discount.toFixed(0);
};

const normalizedSpecial = computed(() =>
  props.specialIsNormalized
    ? props.special || null
    : normalizeProductSpecial(props.special)
);
</script>
